import React, { useEffect, useState } from 'react';
import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { Link } from 'react-router-dom';

const Clientes = () => {
  const [clientes, setClientes] = useState([]);
  const [nombre, setNombre] = useState('');
  const [cedula, setCedula] = useState('');
  const [telefono, setTelefono] = useState('');
  const [vehiculo, setVehiculo] = useState('');
  const [tipoCliente, setTipoCliente] = useState('natural');
  const [rif, setRif] = useState('');
  const [porcentajeRetencion, setPorcentajeRetencion] = useState(75);

  const clientesRef = collection(db, 'clientes');

  const obtenerClientes = async () => {
    const data = await getDocs(clientesRef);
    setClientes(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
  };

  const agregarCliente = async (e) => {
    e.preventDefault();
    if (!nombre || !cedula || !telefono) return;

    await addDoc(clientesRef, {
      nombre,
      cedula,
      telefono,
      vehiculo,
      tipo: tipoCliente,
      rif: tipoCliente === 'juridico' ? rif : '',
      porcentajeRetencion: tipoCliente === 'juridico' ? porcentajeRetencion : 0
    });

    setNombre('');
    setCedula('');
    setTelefono('');
    setVehiculo('');
    setTipoCliente('natural');
    setRif('');
    setPorcentajeRetencion(75);
    obtenerClientes();
  };

  const eliminarCliente = async (id) => {
    await deleteDoc(doc(db, 'clientes', id));
    obtenerClientes();
  };

  useEffect(() => {
    obtenerClientes();
  }, []);

  return (
    <div className="clientes-container">
      <h2>Clientes</h2>

      <form onSubmit={agregarCliente} className="clientes-form">
        <input type="text" placeholder="Nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        <input type="text" placeholder="Cédula" value={cedula} onChange={(e) => setCedula(e.target.value)} />
        <input type="text" placeholder="Teléfono" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
        <input type="text" placeholder="Vehículo (opcional)" value={vehiculo} onChange={(e) => setVehiculo(e.target.value)} />

        <select value={tipoCliente} onChange={(e) => setTipoCliente(e.target.value)}>
          <option value="natural">Natural</option>
          <option value="juridico">Jurídico</option>
        </select>

        {tipoCliente === 'juridico' && (
          <>
            <input type="text" placeholder="RIF" value={rif} onChange={(e) => setRif(e.target.value)} />
            <select value={porcentajeRetencion} onChange={(e) => setPorcentajeRetencion(Number(e.target.value))}>
              <option value={75}>Retiene 75%</option>
              <option value={100}>Retiene 100%</option>
            </select>
          </>
        )}

        <button type="submit">Agregar</button>
      </form>

      <ul className="clientes-lista">
        {clientes.map((cliente) => (
          <li key={cliente.id} className="cliente-card">
            <div className="cliente-info">
              <Link to={`/clientes/${cliente.id}`}>{cliente.nombre}</Link><br />
              <span>Cédula: {cliente.cedula}</span><br />
              <span>Teléfono: {cliente.telefono}</span><br />
              {cliente.vehiculo && <span>Vehículo: {cliente.vehiculo}</span>}<br />
              {cliente.tipo === 'juridico' && (
                <>
                  <span>RIF: {cliente.rif}</span><br />
                  <span>Retención: {cliente.porcentajeRetencion}%</span>
                </>
              )}
            </div>
            <button onClick={() => eliminarCliente(cliente.id)}>Eliminar</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Clientes;
